import React from "react";
import {
  HashRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import './services/i18n';
import { useTranslation } from "react-i18next";

import LocationsPage from "./pages/LocationsPage";

export default function App() {
  const { i18n } = useTranslation();

  // eslint-disable-next-line
  const [currentLanguage, setCurrentLanguage] = React.useState(() => {
    let language = 'de';

    const pathname = window.location.pathname;
    // const pathname = '/en/locations';
    // const pathname = '/standorte';

    const regex = /\/(en){1}\//g;
    const found = pathname.match(regex);

    if (found) {
      language = found[0].substring(1, 3);
    }

    i18n.changeLanguage(language);

    return language;
  });

  return (
    <Router>
      <div>
        {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
        <Switch>
          <Route path="/">
            <LocationsPage currentLanguage={currentLanguage} />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}
